import { useEffect } from 'react';
import { expressionFunction } from 'vega';

// simple wordwrap function based on an approximation of average character width
const wordWrap = (x: string, width: number, charAvgWidth = 7.5) => {
  const nbrChar = Math.floor(width / charAvgWidth); // approximation

  return x.split(' ').reduce((acc: string[], cur: string) => {
    if (acc.length === 0) {
      acc.push(cur);
    } else {
      if ((acc.at(-1) ?? '').length + cur.length + 1 >= nbrChar) {
        acc.push(cur);
      } else {
        acc[acc.length - 1] += ' ' + cur;
      }
    }
    return acc;
  }, []);
};

export const useVegaFunctions = () => {
  useEffect(() => {
    expressionFunction('amWordWrap', wordWrap);
  }, []);
};
